import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useGetCumulativeAssignmentReportWithRetakesMutation } from '../../../../../../features/authentication/reportApiSlice';

const ClassRetakeReport = () => {
  const [getCumulativeAssignmentReportWithRetakes] = useGetCumulativeAssignmentReportWithRetakesMutation();

  var headerOptions = {
    reportTitle: 'Class Retake Report',
    showClassDropdown: false,
    showTeacherName: true,
    showStudentName: true,
    showClassName: false,
    isAllStudentReport: true,
    showRetryInfo: true,
    showTotalRow: true,
    showReportType: true,
    reportType: 'Assignment'
  };

  return (
    <QuestionBreakdownReport
      includeRetakeData={true}
      exportFileName='ClassRetakeReport'
      reportDataEndpoint={getCumulativeAssignmentReportWithRetakes}
      headerOptions={headerOptions}
      goBackOnError={true}
      />
  );
};

export default ClassRetakeReport;